<template>
  <div id="app">
    <router-view />
    <notifications/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
  let app = this
  app.renderFavIcon()
  },
  methods: {
    renderFavIcon() {
      let app = this
      let favicon = document.getElementById("favicon");
      favicon.href = 'https://enrollprime.com/wp-content/uploads/2022/11/cropped-Favicon-192x192.png'
      document.title = `C123 | ${app.$route.name}`
    }
  }
}
</script>